import ReplyComment from './reply-button';

export default ReplyComment;
